import { render, staticRenderFns } from "./PayeeMatchUsageGuide.vue?vue&type=template&id=56431d35&scoped=true&"
import script from "./PayeeMatchUsageGuide.vue?vue&type=script&lang=js&"
export * from "./PayeeMatchUsageGuide.vue?vue&type=script&lang=js&"
import style0 from "./PayeeMatchUsageGuide.vue?vue&type=style&index=0&id=56431d35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56431d35",
  null
  
)

export default component.exports